export class ConfigurationUtility {

    static getDataFromDOM<T>(documentRef: Document, selector: string): T | null {
        const data = documentRef.querySelector(selector);

        if (!data) {
            return null;
        }

        return { ...JSON.parse(data.innerHTML) } as T;
    }

    static getInjectedConfiguration<T>(documentRef: Document, scriptName: string): T {
        const scriptElementList = documentRef.querySelectorAll('script');
        let scriptElement: HTMLScriptElement | undefined;

        if (!scriptElementList) {
            throw new Error('No script elements found');
        }

        for (let i = 0; i < scriptElementList.length; i++) {
            const element = scriptElementList[i];

            if (
                element.hasAttribute('src') &&
                element.getAttribute('src')!.length > 0 &&
                element.getAttribute('src')!.indexOf(scriptName) > -1
            ) {
                scriptElement = element;
            }
        }

        if (!scriptElement) {
            throw new Error(`No element with ${scriptName} in src!`);
        }

        // scriptElement.getAttributeNames().map(attrName => {
        //     console.log(attrName);
        // })

        return {} as T;
    }

}
